import { render } from "./HeroSimple.vue?vue&type=template&id=fdf95e0a"
import script from "./HeroSimple.vue?vue&type=script&lang=js"
export * from "./HeroSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__